var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg64(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "187px",
    height: "187px",
    viewBox: "0 0 187 187",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M108.867 2.03131L128.257 133.021Q128.265 133.078 128.267 133.137Q128.269 133.195 128.264 133.254Q128.259 133.312 128.247 133.369Q128.235 133.426 128.217 133.482Q128.198 133.537 128.173 133.59Q128.148 133.643 128.118 133.693Q128.087 133.743 128.051 133.788Q128.014 133.834 127.973 133.875Q127.931 133.917 127.885 133.953Q127.839 133.989 127.789 134.019Q127.739 134.05 127.686 134.074Q127.633 134.099 127.578 134.117Q127.522 134.135 127.465 134.146Q127.407 134.158 127.349 134.163Q127.291 134.167 127.232 134.165Q127.174 134.163 127.116 134.154L1.88436 114.833Q1.85078 114.828 1.81762 114.82Q1.78446 114.813 1.75189 114.803Q1.71931 114.793 1.68747 114.781Q1.65563 114.769 1.62467 114.755Q1.59371 114.741 1.56378 114.725Q1.53384 114.709 1.50507 114.691Q1.4763 114.673 1.44882 114.653Q1.42134 114.633 1.39529 114.611Q1.36923 114.589 1.34472 114.566Q1.32021 114.542 1.29735 114.517Q1.2745 114.492 1.25341 114.465Q1.23231 114.439 1.21308 114.411Q1.19385 114.383 1.17656 114.354Q1.15928 114.324 1.14402 114.294Q1.12876 114.264 1.1156 114.232Q1.10245 114.201 1.09145 114.169Q1.08045 114.137 1.07166 114.104Q1.06288 114.071 1.05634 114.038Q1.0498 114.004 1.04555 113.97Q1.0413 113.937 1.03934 113.903Q1.03739 113.869 1.03775 113.835Q1.0381 113.801 1.04077 113.767Q1.04343 113.733 1.0484 113.7Q1.05336 113.666 1.06059 113.633Q1.06783 113.6 1.0773 113.567Q1.08678 113.534 1.09845 113.502Q1.11012 113.47 1.12393 113.439Q1.13775 113.408 1.15364 113.378Q1.16953 113.348 1.18743 113.319Q1.20532 113.29 1.22514 113.263Q1.24496 113.235 1.26661 113.209Q1.28825 113.183 1.31163 113.158L107.154 1.49036Q107.178 1.46502 107.204 1.44141Q107.23 1.41781 107.257 1.39606Q107.284 1.37431 107.313 1.35452Q107.342 1.33473 107.372 1.317Q107.402 1.29927 107.433 1.28368Q107.464 1.26809 107.497 1.25472Q107.529 1.24135 107.562 1.23027Q107.595 1.21918 107.629 1.21044Q107.663 1.20169 107.697 1.19533Q107.731 1.18896 107.766 1.18501Q107.801 1.18106 107.836 1.17954Q107.871 1.17802 107.905 1.17894Q107.94 1.17986 107.975 1.18321Q108.01 1.18657 108.044 1.19234Q108.079 1.19811 108.113 1.20627Q108.147 1.21444 108.18 1.22495Q108.213 1.23546 108.246 1.24828Q108.278 1.26109 108.31 1.27614Q108.341 1.29119 108.372 1.3084Q108.402 1.32561 108.431 1.3449Q108.46 1.36419 108.488 1.38547Q108.516 1.40674 108.542 1.4299Q108.568 1.45306 108.592 1.47798Q108.617 1.50291 108.639 1.52948Q108.662 1.55605 108.683 1.58414Q108.704 1.61223 108.722 1.64169Q108.741 1.67116 108.758 1.70187Q108.774 1.73257 108.789 1.76436Q108.803 1.79615 108.815 1.82887Q108.828 1.86159 108.837 1.89508Q108.847 1.92857 108.855 1.96267Q108.862 1.99677 108.867 2.03131L108.867 2.03131Z",
    transform: "matrix(-0.70710677 -0.70710677 0.70710677 -0.70710677 90.86636 185.90839)",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.867 2.03131L128.257 133.021Q128.265 133.078 128.267 133.137Q128.269 133.195 128.264 133.254Q128.259 133.312 128.247 133.369Q128.235 133.426 128.217 133.482Q128.198 133.537 128.173 133.59Q128.148 133.643 128.118 133.693Q128.087 133.743 128.051 133.788Q128.014 133.834 127.973 133.875Q127.931 133.917 127.885 133.953Q127.839 133.989 127.789 134.019Q127.739 134.05 127.686 134.074Q127.633 134.099 127.578 134.117Q127.522 134.135 127.465 134.146Q127.407 134.158 127.349 134.163Q127.291 134.167 127.232 134.165Q127.174 134.163 127.116 134.154L1.88436 114.833Q1.85078 114.828 1.81762 114.82Q1.78446 114.813 1.75189 114.803Q1.71931 114.793 1.68747 114.781Q1.65563 114.769 1.62467 114.755Q1.59371 114.741 1.56378 114.725Q1.53384 114.709 1.50507 114.691Q1.4763 114.673 1.44882 114.653Q1.42134 114.633 1.39529 114.611Q1.36923 114.589 1.34472 114.566Q1.32021 114.542 1.29735 114.517Q1.2745 114.492 1.25341 114.465Q1.23231 114.439 1.21308 114.411Q1.19385 114.383 1.17656 114.354Q1.15928 114.324 1.14402 114.294Q1.12876 114.264 1.1156 114.232Q1.10245 114.201 1.09145 114.169Q1.08045 114.137 1.07166 114.104Q1.06288 114.071 1.05634 114.038Q1.0498 114.004 1.04555 113.97Q1.0413 113.937 1.03934 113.903Q1.03739 113.869 1.03775 113.835Q1.0381 113.801 1.04077 113.767Q1.04343 113.733 1.0484 113.7Q1.05336 113.666 1.06059 113.633Q1.06783 113.6 1.0773 113.567Q1.08678 113.534 1.09845 113.502Q1.11012 113.47 1.12393 113.439Q1.13775 113.408 1.15364 113.378Q1.16953 113.348 1.18743 113.319Q1.20532 113.29 1.22514 113.263Q1.24496 113.235 1.26661 113.209Q1.28825 113.183 1.31163 113.158L107.154 1.49036Q107.178 1.46502 107.204 1.44141Q107.23 1.41781 107.257 1.39606Q107.284 1.37431 107.313 1.35452Q107.342 1.33473 107.372 1.317Q107.402 1.29927 107.433 1.28368Q107.464 1.26809 107.497 1.25472Q107.529 1.24135 107.562 1.23027Q107.595 1.21918 107.629 1.21044Q107.663 1.20169 107.697 1.19533Q107.731 1.18896 107.766 1.18501Q107.801 1.18106 107.836 1.17954Q107.871 1.17802 107.905 1.17894Q107.94 1.17986 107.975 1.18321Q108.01 1.18657 108.044 1.19234Q108.079 1.19811 108.113 1.20627Q108.147 1.21444 108.18 1.22495Q108.213 1.23546 108.246 1.24828Q108.278 1.26109 108.31 1.27614Q108.341 1.29119 108.372 1.3084Q108.402 1.32561 108.431 1.3449Q108.46 1.36419 108.488 1.38547Q108.516 1.40674 108.542 1.4299Q108.568 1.45306 108.592 1.47798Q108.617 1.50291 108.639 1.52948Q108.662 1.55605 108.683 1.58414Q108.704 1.61223 108.722 1.64169Q108.741 1.67116 108.758 1.70187Q108.774 1.73257 108.789 1.76436Q108.803 1.79615 108.815 1.82887Q108.828 1.86159 108.837 1.89508Q108.847 1.92857 108.855 1.96267Q108.862 1.99677 108.867 2.03131L108.867 2.03131Z",
    transform: "matrix(-0.70710677 -0.70710677 0.70710677 -0.70710677 90.86636 185.90839)",
    id: "Rectangle",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "matrix(0.81915206 -0.57357645 0.57357645 0.81915206 -58.146633 67.150955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.95192 0L2.95192 172.796L0 172.796L0 0Z",
    transform: "translate(0.33320665 1.7253828)",
    id: "Rectangle",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.95192 0L2.95192 172.796L0 172.796L0 0Z",
    transform: "translate(15.738732 2.0754054)",
    id: "Rectangle",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.95192 0L2.95192 172.796L0 172.796L0 0Z",
    transform: "translate(28.336811 1.5126622)",
    id: "Rectangle-Copy-3",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.95192 0L2.95192 172.796L0 172.796L0 0Z",
    transform: "translate(43.742336 1.8626847)",
    id: "Rectangle-Copy-4",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.95192 0L2.95192 172.796L0 172.796L0 0Z",
    transform: "translate(59.147865 2.2127073)",
    id: "Rectangle-Copy-5",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.95192 0L2.95192 172.796L0 172.796L0 0Z",
    transform: "translate(71.74594 1.6499641)",
    id: "Rectangle-Copy-6",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.95192 0L2.95192 172.796L0 172.796L0 0Z",
    transform: "translate(87.15147 1.9999866)",
    id: "Rectangle-Copy-7",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.95192 0L2.95192 172.796L0 172.796L0 0Z",
    transform: "translate(101.804054 0.09830044)",
    id: "Rectangle-Copy-8",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.95192 0L2.95192 172.796L0 172.796L0 0Z",
    transform: "translate(116.36411 2.634373)",
    id: "Rectangle-Copy-9",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.95192 0L2.95192 172.796L0 172.796L0 0Z",
    transform: "translate(130.56061 2.1372886)",
    id: "Rectangle-Copy-10",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.95192 0L2.95192 172.796L0 172.796L0 0Z",
    transform: "translate(145.21318 0.23560236)",
    id: "Rectangle-Copy-11",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.95192 0L2.95192 172.796L0 172.796L0 0Z",
    transform: "translate(158.56421 1.9245679)",
    id: "Rectangle-Copy-12",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.95192 0L2.95192 172.796L0 172.796L0 0Z",
    transform: "translate(174.42583 0.8699886)",
    id: "Rectangle-Copy-13",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.95192 0L2.95192 172.796L0 172.796L0 0Z",
    transform: "translate(187.97154 2.16823)",
    id: "Rectangle-Copy-14",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg64);
export default __webpack_public_path__ + "static/media/64.a132ade09125b66775c96965885f929f.svg";
export { ForwardRef as ReactComponent };